/**
 * Labstep
 *
 * @module components/Thread/Form
 * @desc Comment form + comment list
 */

import { CommentEmptyState } from 'labstep-web/components/Comment/EmptyState';
import { CommentFormCreateCreateContainer as CreateCommentForm } from 'labstep-web/components/Comment/Form/Create';
import { CommentListReadContainer as CommentList } from 'labstep-web/components/Comment/List';
import { CanCreate } from 'labstep-web/components/Entity/Can';
import type React from 'react';
import styles from './styles.module.scss';
import type {
  IThreadFormProps,
  IThreadFormViewComponentProps,
} from './types';

export const scrollFunction = () => {
  const mainContentChildrenElement =
    document.getElementById('right-pane-body');
  if (!mainContentChildrenElement) {
    return;
  }
  mainContentChildrenElement.scrollTop =
    mainContentChildrenElement.scrollHeight;
};

export const scrollToBottom = () => {
  setTimeout(scrollFunction, 0);
};

const onSuccess = scrollToBottom;

export const ThreadFormViewComponent: React.FC<
  IThreadFormViewComponentProps
> = ({
  createThreadId,
  readThreadIds,
  experimentWorkflow,
  entityNameLabel,
  header,
  noCommentsMessage,
  showCreateComment = true,
}) => (
  <div className={styles.container} id="thread">
    <div>
      <CommentList
        noCommentsMessage={noCommentsMessage || <CommentEmptyState />}
        threadId={readThreadIds}
        experimentWorkflow={experimentWorkflow}
        header={header}
      />
    </div>
    {showCreateComment && (
      <CanCreate
        parentName="thread"
        parentId={createThreadId}
        entityName="comment"
      >
        <div className={styles.create}>
          <CreateCommentForm
            onSuccess={onSuccess}
            threadId={createThreadId}
            placeholder={`Add your ${entityNameLabel}`}
          />
        </div>
      </CanCreate>
    )}
  </div>
);

export const ThreadForm: React.FC<IThreadFormProps> = (props) => {
  if (!props.disableAutoScroll) {
    scrollToBottom();
  }
  return <ThreadFormViewComponent {...props} />;
};
